export default {
  DARK: {
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight
  }
}
